import React, { useState, useEffect } from 'react';
import { Box, Typography, Card, CardContent, List, ListItem, ListItemText, Divider, Alert, Button } from '@mui/material';
import FeatureGuard from '../components/common/FeatureGuard';
import { useDecodedToken } from '../utils/useDecodedToken';

const Savings: React.FC = () => {
  const user = useDecodedToken();
  const [loading, setLoading] = useState(false);
  const [savings, setSavings] = useState<any[]>([]);

  useEffect(() => {
    // TODO: Replace with real API call when ready
    setLoading(false);
    setSavings([]);
  }, []);

  return (
    <FeatureGuard feature="savings">
      <Box sx={{ p: 3, maxWidth: 700, mx: 'auto' }}>
        <Typography variant="h4" gutterBottom>Savings</Typography>

        {loading ? (
          <Typography>Loading...</Typography>
        ) : savings.length === 0 ? (
          <Card>
            <CardContent>
              <Typography variant="h6" sx={{ mb: 1 }}>Your Savings Accounts</Typography>
              <Alert severity="info">
                <Typography variant="body2">
                  {user?.accountNumber
                    ? 'You do not have any savings accounts yet. Visit a branch or contact support to open one.'
                    : 'No savings accounts to display. Link your SMEDCO account number to view savings information. You can still apply for a loan from the Loan Applications page.'}
                </Typography>
              </Alert>
              <Box sx={{ mt: 2 }}>
                {!user?.accountNumber && (
                  <Button variant="outlined" href="/profile" sx={{ mr: 1 }}>
                    Verify Account Number
                  </Button>
                )}
                <Button variant="contained" href="/loan-application">
                  Go to Loan Applications
                </Button>
              </Box>
            </CardContent>
          </Card>
        ) : (
          <Card>
            <CardContent>
              <Typography variant="h6" sx={{ mb: 2 }}>Your Savings Accounts</Typography>
              <List>
                {savings.map((s: any) => (
                  <React.Fragment key={s.id}>
                    <ListItem alignItems="flex-start">
                      <ListItemText
                        primary={`${s.product} (${s.accountNo})`}
                        secondary={
                          <>
                            <Typography component="span" variant="body2" color="text.primary">
                              Balance: ${s.balance?.toLocaleString?.() || 0}<br />
                              Interest Rate: {s.interestRate || 0}%<br />
                              Status: {s.status || 'N/A'}
                            </Typography>
                          </>
                        }
                      />
                    </ListItem>
                    <Divider component="li" />
                  </React.Fragment>
                ))}
              </List>
            </CardContent>
          </Card>
        )}
      </Box>
    </FeatureGuard>
  );
};

export default Savings; 